import { render, staticRenderFns } from "./Goodsreceipt.vue?vue&type=template&id=3761bfad&scoped=true&"
import script from "./Goodsreceipt.vue?vue&type=script&lang=js&"
export * from "./Goodsreceipt.vue?vue&type=script&lang=js&"
import style0 from "./Goodsreceipt.vue?vue&type=style&index=0&id=3761bfad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3761bfad",
  null
  
)

export default component.exports